(() => {
  let returnFocus;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-lht-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lhtOpen);
      if (!dialog) return;
      returnFocus = opener;
      opener.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-lht-close]');
    if (closer) closer.closest('dialog').close();
    const dialog = event.target.closest('.lht-dialog');
    if (dialog && event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) dialog.close();
    }
    const arrow = event.target.closest('[data-lht-scroll]');
    if (arrow) {
      const track = document.getElementById(arrow.dataset.lhtTarget);
      if (track) track.scrollBy({left: track.clientWidth * Number(arrow.dataset.lhtScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    document.querySelectorAll('.lht-desktop-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
    if (event.target.closest('.lht-dialog a')) dialog?.close();
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.lht-dialog')) return;
    returnFocus?.setAttribute('aria-expanded', 'false');
    returnFocus?.focus();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.lht-desktop-nav details[open]').forEach(details => {
        details.open = false;
        details.querySelector('summary').focus();
      });
    }
  });
})();
